<div
  class="app-table app-table-hoverable-rows hunter-grid local-grid"
  [class.app-table-striped]="striped"
  [class.app-table-resizable]="resizable"
  [class.no-wrap]="!wordWrap"
  [class.fitted]="fitted"
>
  <div class="app-table-wrapper">
    <table class="app-table-table" role="table">
      @if (showHeaders) {
        <thead class="app-table-thead">
          <tr
            cdkDropList
            cdkDropListOrientation="horizontal"
            [cdkDropListDisabled]="!reorderable"
            (cdkDropListDropped)="onColumnDrop($event)"
          >
            @for (column of shown; track column.id) {
              <th
                cdkDrag
                cdkDragLockAxis="x"
                cdkDragPreviewClass="app-column-drag-preview"
                [cdkDragDisabled]="!reorderable"
                (cdkDragStarted)="dragging = true"
                (cdkDragEnded)="onColumnDragEnded()"
                [attr.data-column]="column.id"
                [class.app-sortable-column]="column.sortable"
                [class.app-highlight]="sort?.field === column.id"
                [style.width.px]="column.shownWidth ?? column.fitWidth"
                [style.text-align]="column.align"
                [attr.tabindex]="column.sortable ? 0 : null"
                (click)="onHeaderClick($event, column)"
                (keydown.enter)="onHeaderClick($event, column)"
                (contextmenu)="onHeaderContextMenu($event, column)"
              >
                @if (column.headerTemplate && templates[column.headerTemplate]) {
                  <ng-container
                    [ngTemplateOutlet]="templates[column.headerTemplate]"
                  ></ng-container>
                } @else {
                  {{ column.header
                  }}@if (column.sortable) {<app-sort-icon [field]="column.id" [sort]="sort"></app-sort-icon>}
                }
                @if (resizable) {
                  <span
                    appColumnResizer
                    (columnResize)="onColumnResize($event)"
                  ></span>
                }
              </th>
            }
            @if (editable) {
              <th class="edit-column"></th>
            }
          </tr>
        </thead>
      }
      <tbody class="app-table-tbody">
        @for (row of pageRows; track $index; let index = $index) {
          <tr>
            <!-- The minimum width is on the cells only, as the header text
            sets the minimum width of a column. -->
            @for (column of shown; track column.id) {
              <td
                [style.width.px]="column.shownWidth"
                [style.min-width.px]="column.shownWidth"
                [style.text-align]="column.align"
              >
                @if (column.template && templates[column.template]) {
                  <ng-container
                    [ngTemplateOutlet]="templates[column.template]"
                    [ngTemplateOutletContext]="{
                      $implicit: row,
                      value: column.field ? row[column.field] : null,
                      rowIndex: first + index,
                      isAlt: isAltRow(first + index),
                    }"
                  ></ng-container>
                } @else {
                  {{
                    (column.field ? row[column.field] : null)
                      | cellFormat
                        : $any({
                            dataType: column.dataType || 'string',
                            format: column.format,
                          })
                  }}
                }
              </td>
            }
            @if (editable) {
              <td class="edit-column">
                <button
                  type="button"
                  class="edit-button"
                  title="Edit"
                  (click)="edit.emit(row)"
                >
                  <i class="fa-solid fa-pen"></i>
                </button>
              </td>
            }
          </tr>
        } @empty {
          <tr>
            <td
              class="no-data"
              [attr.colspan]="shown.length + (editable ? 1 : 0)"
            >
              No data
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  @if (sortedRows.length > pageSize) {
    <app-paginator
      [totalRecords]="sortedRows.length"
      [rows]="pageSize"
      [(first)]="first"
      [showFirstLastIcon]="false"
    ></app-paginator>
  }
</div>
<app-context-menu #headerMenu [model]="headerMenuItems"></app-context-menu>
